import { render, staticRenderFns } from "./FoodsSimulator.vue?vue&type=template&id=72ce9b7f"
import script from "./FoodsSimulator.vue?vue&type=script&lang=js"
export * from "./FoodsSimulator.vue?vue&type=script&lang=js"
import style0 from "./FoodsSimulator.vue?vue&type=style&index=0&id=72ce9b7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports